
import { useAuth0 } from "@auth0/auth0-vue";
import { useAuthStore } from "@/stores/authStore";
import { useApiStore } from "@/stores/apiStore";
// import decode from 'jwt-decode';
import { defineComponent } from "vue";
import { AxiosError } from "axios";
import { useSiteStore } from "@/stores/siteStore";
import axios from "axios";
import { CustomErrorCodes } from "@/utils/CustomErrorCodes";
import { useSupportRequestStore } from "@/stores/supportRequestStore";
import SupportRequest from "@/components/supportRequest/index.vue";

export default defineComponent({
	setup() {
		const api = useApiStore();
		const authStore = useAuthStore();
		const siteStore = useSiteStore();
		const supportRequestStore = useSupportRequestStore();
		return {
			api,
			authStore,
			siteStore,
			supportRequestStore
		};
	},
	mounted() {
		const { loginWithRedirect, user, isAuthenticated } = useAuth0(); // Cant find the types for this yet.  TODO
		this.loginWithRedirect = loginWithRedirect; // eslint-disable-next-line
		this.user = user as any; // eslint-disable-next-line
		this.isAuthenticated = isAuthenticated as any;

		if (localStorage.getItem("login-error")) {
			this.errorMessage = localStorage.getItem("login-error") || "";
			localStorage.removeItem("login-error");
		}
	},
	name: "imdex-login",
	components: {
		SupportRequest
	},
	data: () => {
		return {
			// eslint-disable-next-line
			loginWithRedirect: {} as any,
			isAuthenticated: false,
			user: { name: "", email: "" } as AuthUser,
			email: "",
			password: "",
			isLoading: false,
			errorMessage: "",
			supportRequestOpen: false
		};
	},
	methods: {
		async login() {
			await this.loginWithRedirect({ prompt: "login" });
		},
		async submitLogin() {
			this.isLoading = true;
			try {
				await this.authStore.login({ email: this.email, password: this.password });
			} catch (e) {
				if (e instanceof AxiosError) {
					if (e.response != null)
						this.errorMessage = e.response.data.message || e.response.data;
				} else if (e instanceof Error) {
					switch (e.message) {
						case CustomErrorCodes.SiteMissing:
							this.errorMessage = CustomErrorCodes.SiteMissing;
							break;
						default:
							this.errorMessage = this.$t("login.errorMessage");
					}
				} else {
					this.errorMessage = this.$t("login.errorMessage");
				}
				this.isLoading = false;
				this.siteStore.SET_INITIALIZED(false);

				localStorage.removeItem("mineportal-oauth-token");
				localStorage.removeItem("mineportal-auth-token");
				localStorage.removeItem("mineportal-active-site");
				localStorage.removeItem("sessionUrl");
				delete axios.defaults.headers.common["Authorization"];
			}
		},
		forgot(type: string) {
			console.log(type);
		},
		async submitCreateSupportRequest() {
			this.supportRequestOpen = true;
			this.supportRequestStore.open();
		}
	}
});
